import { defineField } from '@/form/useForm'
import { EAssetAutomationLevel, EAssetType, evaluateAssetAutomationLevel } from 'findef'
import type { UseAssetFormComputedData, UseAssetFormState } from '../types'
import { lockedByTicker } from '../toolips'
import { EFormEventHookOrder } from '@/form/useForm/eventHook'

export const symbolField = () => {
  return defineField<UseAssetFormState, string, UseAssetFormComputedData>({
    type: 'text',
    needs: ['asset.type', 'asset.cryptoQuote', 'asset.companyProfile', 'asset.commodityQuote', 'isEditMode'],
    hooks: {
      manualTicker: {
        order: EFormEventHookOrder.EARLY,
        fun: () => {
          return {
            value: ''
          }
        }
      }
    },
    next: (state) => {
      let value: string | undefined = state.symbol;
      const commodity = state.asset.commodityQuote;
      const company = state.asset.companyProfile;
      const crypto = state.asset.cryptoQuote;
      if (commodity) value = commodity.manuallyAdded ? state.symbol || state.asset.symbol : (commodity.symbol || state.symbol || state.asset.symbol);
      else if (company) value = company.symbol || company.isin || state.symbol || state.asset.symbol;
      else if (crypto && !crypto.manuallyAdded) value = crypto.prettySymbol || crypto.symbol || state.symbol || state.asset.symbol;

      if (state.isEditMode) {
        value = state.symbol;
      }

			const label = state.asset.type === EAssetType.COMMODITY ? 'Ticker Symbol' : 'Symbol';
			const placeholder = state.asset.type === EAssetType.COMMODITY ? 'Enter ticker symbol' : 'Enter Symbol';
			const tooltip = state.asset.type === EAssetType.COMMODITY
				? "Enter the ticker symbol for this commodity if you've added one manually and it is not availabile in our list"
				: undefined;

      return {
        value: value,
        placeholder: placeholder,
        tooltip: tooltip,
				label: label,
        locked: evaluateAssetAutomationLevel(state.asset) === EAssetAutomationLevel.SEMI_AUTOMATIC,
        ...(((commodity && !commodity.manuallyAdded) || (crypto && !crypto.manuallyAdded) || (company && !company.manuallyAdded)) ? lockedByTicker(state) : { lockedReasonBubbletip: undefined })
      }
    }
  })
}
